import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spinner, Modal, Button } from "react-bootstrap";
import { getuserdata, decryptId } from "../../services/apiService";
import { oneKlicks } from "../../SDK/oneclick";
import usePaymentMethods from "../../Uitiles/paymentMethods";
import { getSettings } from "../../services/settingsService";

const PaymentPage = () => {
    const paymentMethods = usePaymentMethods();
    const { invoiceId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(true);
    const [paymentMethod, setPaymentMethod] = useState("razorpay");
    const [processing, setProcessing] = useState(false);
    const [userdata, setUserdata] = useState({});
    const [razorpayLoaded, setRazorpayLoaded] = useState(false);
    const [paypalLoaded, setPaypalLoaded] = useState(false);
    const [settings, setSettings] = useState({});
    const [RAZORPAY_KEY_ID, setRAZORPAY_KEY_ID] = useState('');
    const [razorpayKeySecret, setRazorpayKeySecret] = useState('');
    const [PAYPAL_CLIENT_ID, setPAYPAL_CLIENT_ID] = useState('');
    const [PAYPAL_CLIENT_SECRET, setPAYPAL_CLIENT_SECRET] = useState('');
    const [settingsLoaded, setSettingsLoaded] = useState(false);
    const [showBankDetails, setShowBankDetails] = useState(false);
    const [bankDetails, setBankDetails] = useState({});

    // Load settings and API keys
    useEffect(() => {
        const loadSettings = async () => {
            try {
                const settingsData = await getSettings();
                console.log('Loaded settings:', settingsData);
                setSettings(settingsData);
                
                if (settingsData.razorpay_key_id) {
                    setRAZORPAY_KEY_ID(settingsData.razorpay_key_id);
                    console.log('Razorpay Key ID set:', settingsData.razorpay_key_id);
                }
                
                if (settingsData.razorpay_key_secret) {
                    setRazorpayKeySecret(settingsData.razorpay_key_secret);
                }
                
                if (settingsData.paypal_client_id) {
                    setPAYPAL_CLIENT_ID(settingsData.paypal_client_id);
                    console.log('PayPal Client ID set:', settingsData.paypal_client_id);
                }

                if (settingsData.paypal_client_secret) {
                    setPAYPAL_CLIENT_SECRET(settingsData.paypal_client_secret);
                    console.log('PayPal Client Secret set:', settingsData.paypal_client_secret);
                }
                
                setSettingsLoaded(true);
            } catch (error) {
                console.error('Error loading settings:', error);
                // Fallback to test keys if settings fail to load
                setRAZORPAY_KEY_ID('rzp_live_SxrHxAcaqcutXT');
                setRazorpayKeySecret('U0PKiM2h6J6S86ZCMQ82WdFG');
                setSettingsLoaded(true);
            }
        };
        
        loadSettings();
    }, []);

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            setUserdata(JSON.parse(userData));
        }
        fetchInvoiceDetails();
        initializeRazorpay();
        initializePayPal();
    }, [invoiceId]);


    const initializeRazorpay = () => {
        return new Promise((resolve) => {
            if (window.Razorpay) {
                setRazorpayLoaded(true);
                resolve();
                return;
            }
            
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => {
                setRazorpayLoaded(true);
                resolve();
            };
            script.onerror = () => {
                console.error('Failed to load Razorpay script');
                resolve();
            };
            document.body.appendChild(script);
        });
    };

    const initializePayPal = () => {
        return new Promise((resolve) => {
            if (window.paypal) {
                setPaypalLoaded(true);
                resolve();
                return;
            }
            
            const script = document.createElement('script');
            script.src = 'https://www.paypal.com/sdk/js?client-id=' + (PAYPAL_CLIENT_ID || 'sb') + '&currency=USD';
            script.onload = () => {
                setPaypalLoaded(true);
                resolve();
            };
            script.onerror = () => {
                console.error('Failed to load PayPal SDK');
                resolve();
            };
            document.body.appendChild(script);
        });
    };

    const fetchInvoiceDetails = async () => {
        try {
            setLoading(true);
            const tableSchema = "";
            const tableName = "invoices";
            const conditions = {
                "id": decryptId(invoiceId),
                "client": await getuserdata("id")
            };
            const response = await oneKlicks.read(tableSchema, tableName, conditions);
            
            if (response.success && response.data.length > 0) {
                setInvoice(response.data[0]);
            } else {
                alert("Invoice not found");
                navigate("/doctor/invoices");
            }
        } catch (error) {
            console.error("Error fetching invoice:", error);
            alert("Error loading invoice details");
            navigate("/doctor/invoices");
        } finally {
            setLoading(false);
        }
    };

    const showToast = (message, type = 'success') => {
        const toast = document.createElement('div');
        toast.className = `toast ${type}`;
        toast.textContent = message;
        toast.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: ${type === 'success' ? '#4CAF50' : '#f44336'};
            color: white;
            padding: 16px 24px;
            border-radius: 4px;
            z-index: 10000;
            font-weight: 500;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        `;
        
        document.body.appendChild(toast);
        
        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        }, 3000);
    };

    const handlePayment = async () => {
        if (!invoice) return;
        
        // Check if settings are loaded
        if (!settingsLoaded) {
            showToast('Payment settings are still loading. Please wait...', 'error');
            return;
        }
        
        console.log('paymentMethod', paymentMethod);
        console.log('invoice', invoice);
        console.log('razorpayLoaded', razorpayLoaded);
        console.log('window.Razorpay', window.Razorpay);
        console.log('RAZORPAY_KEY_ID', RAZORPAY_KEY_ID);
        console.log('userdata', userdata);
        console.log('settings', settings);
        console.log('invoiceId', invoiceId);
        console.log('settingsLoaded', settingsLoaded);

        setProcessing(true);
        try {
            if (paymentMethod === "razorpay") {
                if (!razorpayLoaded || !window.Razorpay) {
                    showToast('Razorpay is not loaded. Please try again.', 'error');
                    setProcessing(false);
                    return;
                }
                
                if (!RAZORPAY_KEY_ID) {
                    showToast('Razorpay API key is not available. Please check your settings.', 'error');
                    setProcessing(false);
                    return;
                }

                // Use Razorpay's frontend-only approach without backend API calls
                const options = {
                    key: RAZORPAY_KEY_ID,
                    amount: (parseFloat(invoice.total_amount || 0) - parseFloat(invoice.paid_amount || 0)) * 100, // Convert to paise
                    currency: 'INR',
                    name: 'MeddyList',
                    description: `Payment for Invoice #${invoice.id}`,
                    handler: async function (response) {
                        console.log('Payment successful:', response);
                        showToast('Payment successful!', 'success');
                        
                        // Update invoice status
                        const remainingAmount = parseFloat(invoice.total_amount || 0) - parseFloat(invoice.paid_amount || 0);
                        const updateData = {
                            status: "paid",
                            paid_amount: parseFloat(invoice.paid_amount || 0) + remainingAmount,
                            paid_date: new Date().toISOString(),
                            payment_method: paymentMethod,
                            payment_reference: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature
                        };

                        const tableSchema = "";
                        const tableName = "invoices";
                        const conditions = { "id": decryptId(invoiceId) };
                        
                        const updateResponse = await oneKlicks.update(tableSchema, tableName, conditions, updateData);
                        
                        if (updateResponse.success) {
                            // Create income record for the payment
                            const userid = await getuserdata("id");
                            const timestamp = new Date().getTime();
                            
                            const incomeData = {
                                add_by: userid,
                                transaction_id: timestamp,
                                incomeType: 'invoice_payment',
                                clientYes: invoice.client,
                                amount: remainingAmount,
                                date: new Date().toISOString().split('T')[0],
                                description: `Payment for Invoice #${invoice.id} - ${paymentMethod.toUpperCase()}`,
                                status: 'active',
                                notes: `Payment received for invoice ${invoice.id}`,
                                attachments: '',
                                transactionType: paymentMethod,
                                referenceNumber: response.razorpay_payment_id,
                                toSendAccount: userid
                            };
                            
                            const incomeResponse = await oneKlicks.create(tableSchema, 'income', incomeData, {});
                            
                            if (incomeResponse.success) {
                                // Update balance
                                const balanceConditions = { account_id: userid };
                                const balanceResponse = await oneKlicks.read(tableSchema, 'balance', balanceConditions, 'id DESC', {}, {}, []);
                                
                                if (balanceResponse.success && balanceResponse.data.length > 0) {
                                    const currentBalance = parseFloat(balanceResponse.data[0].amount);
                                    const newBalance = currentBalance + remainingAmount;
                                    
                                    const balanceUpdateData = { amount: newBalance };
                                    const balanceUpdateConditions = { id: balanceResponse.data[0].id };
                                    await oneKlicks.update(tableSchema, 'balance', balanceUpdateData, balanceUpdateConditions);
                                    
                                    // Add balance sheet entry
                                    const balanceSheetData = {
                                        account_id: userid,
                                        transaction_id: timestamp,
                                        credit: remainingAmount,
                                        debit: 0,
                                        balance: newBalance,
                                        date: new Date().toISOString().split('T')[0],
                                        description: `Payment received for invoice ${invoice.id}`,
                                        status: 'active'
                                    };
                                    await oneKlicks.create(tableSchema, 'balance_sheet', balanceSheetData, {});
                                } else {
                                    // Create new balance record if none exists
                                    const newBalanceData = {
                                        account_id: userid,
                                        amount: remainingAmount,
                                        status: "active"
                                    };
                                    const createBalance = await oneKlicks.create(tableSchema, 'balance', newBalanceData, {});

                                    const balanceSheetData = {
                                        account_id: userid,
                                        transaction_id: timestamp,
                                        credit: remainingAmount,
                                        debit: 0,
                                        balance: remainingAmount,
                                        date: new Date().toISOString().split('T')[0],
                                        description: `Payment received for invoice ${invoice.id}`,
                                        status: 'active'
                                    };
                                    await oneKlicks.create(tableSchema, 'balance_sheet', balanceSheetData, {});
                                }
                            }
                            
                            setTimeout(() => {
                                navigate("/doctor/invoices");
                            }, 2000);
                        }
                    },
                    prefill: {
                        name: userdata.name || 'User',
                        contact: userdata.phone || '',
                        email: userdata.email || ''
                    },
                    notes: {
                        invoice_id: invoice.id,
                        invoice_amount: invoice.total_amount
                    },
                    theme: {
                        color: '#007bff'
                    },
                    modal: {
                        ondismiss: function() {
                            setProcessing(false);
                            showToast('Payment cancelled by user.', 'error');
                        }
                    }
                };

                const rzp = new window.Razorpay(options);
                
                rzp.on('payment.failed', function (response) {
                    console.error('Payment failed:', response.error);
                    showToast(`Payment failed: ${response.error.description || 'Unknown error'}`, 'error');
                    setProcessing(false);
                });
                
                rzp.on('payment.error', function (response) {
                    console.error('Payment error:', response.error);
                    showToast(`Payment error: ${response.error.description || 'Unknown error'}`, 'error');
                    setProcessing(false);
                });
                
                rzp.open();
                return;
            } else if (paymentMethod === "paypal") {
                if (!paypalLoaded || !window.paypal) {
                    showToast('PayPal is not loaded. Please try again.', 'error');
                    setProcessing(false);
                    return;
                }
                
                if (!PAYPAL_CLIENT_ID) {
                    showToast('PayPal Client ID is not available. Please check your settings.', 'error');
                    setProcessing(false);
                    return;
                }

                // Create PayPal payment
                try {
                    const paypalOptions = {
                        createOrder: function(data, actions) {
                            return actions.order.create({
                                purchase_units: [{
                                    amount: {
                                        value: (invoice.total_amount / 75).toFixed(2), // Convert INR to USD (approximate)
                                        currency_code: 'USD'
                                    },
                                    description: `Payment for Invoice #${invoice.id}`,
                                    custom_id: `invoice_${invoice.id}`
                                }]
                            });
                        },
                        onApprove: async function(data, actions) {
                            try {
                                const order = await actions.order.capture();
                                console.log('PayPal payment successful:', order);
                                showToast('Payment successful!', 'success');
                                
                                // Update invoice status
                                const updateData = {
                                    status: "paid",
                                    paid_amount: invoice.total_amount,
                                    paid_date: new Date().toISOString(),
                                    payment_method: paymentMethod,
                                    payment_reference: order.id,
                                    paypal_order_id: order.id,
                                    paypal_payer_id: order.payer.payer_id
                                };

                                const tableSchema = "";
                                const tableName = "invoices";
                                const conditions = { "id": decryptId(invoiceId) };
                                
                                const updateResponse = await oneKlicks.update(tableSchema, tableName, conditions, updateData);
                                
                                if (updateResponse.success) {
                                    // Create income record for the payment
                                    const userid = await getuserdata("id");
                                    const timestamp = new Date().getTime();
                                    
                                    const incomeData = {
                                        add_by: userid,
                                        transaction_id: timestamp,
                                        incomeType: 'invoice_payment',
                                        clientYes: invoice.client,
                                        amount: invoice.total_amount,
                                        date: new Date().toISOString().split('T')[0],
                                        description: `Payment for Invoice #${invoice.id} - ${paymentMethod.toUpperCase()}`,
                                        status: 'active',
                                        notes: `Payment received for invoice ${invoice.id}`,
                                        attachments: '',
                                        transactionType: paymentMethod,
                                        referenceNumber: order.id,
                                        toSendAccount: userid
                                    };
                                    
                                    const incomeResponse = await oneKlicks.create(tableSchema, 'income', incomeData, {});
                                    
                                    if (incomeResponse.success) {
                                        // Update balance
                                        const balanceConditions = { account_id: userid };
                                        const balanceResponse = await oneKlicks.read(tableSchema, 'balance', balanceConditions, 'id DESC', {}, {}, []);
                                        
                                        if (balanceResponse.success && balanceResponse.data.length > 0) {
                                            const currentBalance = parseFloat(balanceResponse.data[0].amount);
                                            const newBalance = currentBalance + parseFloat(invoice.total_amount);
                                            
                                            const balanceUpdateData = { amount: newBalance };
                                            const balanceUpdateConditions = { id: balanceResponse.data[0].id };
                                            await oneKlicks.update(tableSchema, 'balance', balanceUpdateData, balanceUpdateConditions);
                                            
                                            // Add balance sheet entry
                                            const balanceSheetData = {
                                                account_id: userid,
                                                transaction_id: timestamp,
                                                credit: parseFloat(invoice.total_amount),
                                                debit: 0,
                                                balance: newBalance,
                                                date: new Date().toISOString().split('T')[0],
                                                description: `Payment received for invoice ${invoice.id}`,
                                                status: 'active'
                                            };
                                            await oneKlicks.create(tableSchema, 'balance_sheet', balanceSheetData, {});
                                        } else {
                                            // Create new balance record if none exists
                                            const newBalanceData = {
                                                account_id: userid,
                                                amount: invoice.total_amount,
                                                status: "active"
                                            };
                                            const createBalance = await oneKlicks.create(tableSchema, 'balance', newBalanceData, {});

                                            const balanceSheetData = {
                                                account_id: userid,
                                                transaction_id: timestamp,
                                                credit: parseFloat(invoice.total_amount),
                                                debit: 0,
                                                balance: parseFloat(invoice.total_amount),
                                                date: new Date().toISOString().split('T')[0],
                                                description: `Payment received for invoice ${invoice.id}`,
                                                status: 'active'
                                            };
                                            await oneKlicks.create(tableSchema, 'balance_sheet', balanceSheetData, {});
                                        }
                                    }
                                    
                                    setTimeout(() => {
                                        navigate("/doctor/invoices");
                                    }, 2000);
                                }
                            } catch (error) {
                                console.error('PayPal payment capture failed:', error);
                                showToast('Payment capture failed. Please try again.', 'error');
                                setProcessing(false);
                            }
                        },
                        onError: function(err) {
                            console.error('PayPal payment error:', err);
                            showToast(`PayPal payment failed: ${err.message || 'Unknown error'}`, 'error');
                            setProcessing(false);
                        },
                        onCancel: function(data) {
                            console.log('PayPal payment cancelled:', data);
                            showToast('Payment cancelled by user.', 'error');
                            setProcessing(false);
                        }
                    };

                    // Render PayPal button
                    const paypalButtonContainer = document.getElementById('paypal-button-container');
                    if (paypalButtonContainer) {
                        paypalButtonContainer.innerHTML = '';
                        window.paypal.Buttons(paypalOptions).render('#paypal-button-container');
                    } else {
                        // Create container if it doesn't exist
                        const container = document.createElement('div');
                        container.id = 'paypal-button-container';
                        container.style.cssText = 'margin: 20px 0;';
                        document.querySelector('.payment-actions').appendChild(container);
                        window.paypal.Buttons(paypalOptions).render('#paypal-button-container');
                    }
                    
                    return;
                } catch (error) {
                    console.error('PayPal initialization failed:', error);
                    showToast('Failed to initialize PayPal payment. Please try again.', 'error');
                    setProcessing(false);
                    return;
                }
            } else if (paymentMethod === "paytm") {
                console.log('Paytm payment method');
            } else if (paymentMethod === "upi") {
                console.log('UPI payment method');
            } else if (paymentMethod === "netbanking") {
                console.log('Net banking payment method');
            } else if (paymentMethod === "card") {
                console.log('Card payment method');
            } else if (paymentMethod === "banking") {
                // I NEED OPEN popup show the bank details
                setShowBankDetails(true);
                const tableSchema = "";
                const tableName = "virtual_accounts";
                const conditions = { "user_id": await getuserdata("id") };
                const orderBy = "id DESC";
                const search = null;
                const pagination = null;
                const margedata = null;
                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                console.log('Bank details:', response);
                //receivers: "[{\"id\":\"ba_RMdcaLIoXJIFtT\",\"entity\":\"bank_account\",\"ifsc\":\"UTIB000RAZP\",\"bank_name\":\"Axis Bank\",\"name\":\"MeddyList\",\"notes\":[],\"account_number\":\"2223003110406015\"}]"
                const receiversData = response.data[0].receivers;
                // Check if receivers is a string and decode JSON
                console.log("receiversData :", receiversData);
                if (typeof receiversData === 'string') {
                    try {
                        console.log("receiversData parse :", receiversData);
                        const parsedReceivers = JSON.parse(receiversData);
                        setBankDetails(parsedReceivers[0]);
                        console.log("receiversData parsedReceivers :", parsedReceivers);
                    } catch (error) {
                        console.error("Error parsing receivers JSON:", error);
                        setBankDetails({});
                    }
                } else {
                    console.log("receiversData :", receiversData);
                    setBankDetails(receiversData && receiversData.length > 0 ? receiversData[0] : {});
                }
                
                
                return;
            } else if (paymentMethod === "payu") {
                console.log('Payu payment method');
            }
            
            // For other payment methods, simulate payment processing

            const updateData = {
                status: "paid",
                paid_amount: invoice.total_amount,
                paid_date: new Date().toISOString(),
                payment_method: paymentMethod,
                payment_reference: `PAY_${Date.now()}`
            };

            const tableSchema = "";
            const tableName = "invoices";
            const conditions = { "id": decryptId(invoiceId) };
            
            const response = await oneKlicks.update(tableSchema, tableName, conditions, updateData);
            
            if (response.success) {
                // Create income record for the payment
                const userid = await getuserdata("id");
                const timestamp = new Date().getTime();
                
                const incomeData = {
                    add_by: userid,
                    transaction_id: timestamp,
                    incomeType: 'invoice_payment',
                    clientYes: invoice.client,
                    amount: invoice.total_amount,
                    date: new Date().toISOString().split('T')[0],
                    description: `Payment for Invoice #${invoice.id} - ${paymentMethod.toUpperCase()}`,
                    status: 'active',
                    notes: `Payment received for invoice ${invoice.id}`,
                    attachments: '',
                    transactionType: paymentMethod,
                    referenceNumber: `PAY_${Date.now()}`,
                    toSendAccount: userid
                };
                
                const incomeResponse = await oneKlicks.create(tableSchema, 'income', incomeData, {});
                
                if (incomeResponse.success) {
                    // Update balance
                    const balanceConditions = { account_id: userid };
                    const balanceResponse = await oneKlicks.read(tableSchema, 'balance', balanceConditions, 'id DESC', {}, {}, []);
                    
                    if (balanceResponse.success && balanceResponse.data.length > 0) {
                        const currentBalance = parseFloat(balanceResponse.data[0].amount);
                        const newBalance = currentBalance + parseFloat(invoice.total_amount);
                        
                        const balanceUpdateData = { amount: newBalance };
                        const balanceUpdateConditions = { id: balanceResponse.data[0].id };
                        await oneKlicks.update(tableSchema, 'balance', balanceUpdateData, balanceUpdateConditions);
                        
                        // Add balance sheet entry
                        const balanceSheetData = {
                            account_id: userid,
                            transaction_id: timestamp,
                            credit: parseFloat(invoice.total_amount),
                            debit: 0,
                            balance: newBalance,
                            date: new Date().toISOString().split('T')[0],
                            description: `Payment received for invoice ${invoice.id}`,
                            status: 'active'
                        };
                        await oneKlicks.create(tableSchema, 'balance_sheet', balanceSheetData, {});
                    } else {
                        // Create new balance record if none exists
                        const newBalanceData = {
                            account_id: userid,
                            amount: invoice.total_amount,
                            status: "active"
                        };
                        const createBalance = await oneKlicks.create(tableSchema, 'balance', newBalanceData, {});

                        const balanceSheetData = {
                            account_id: userid,
                            transaction_id: timestamp,
                            credit: parseFloat(invoice.total_amount),
                            debit: 0,
                            balance: parseFloat(invoice.total_amount),
                            date: new Date().toISOString().split('T')[0],
                            description: `Payment received for invoice ${invoice.id}`,
                            status: 'active'
                        };
                        await oneKlicks.create(tableSchema, 'balance_sheet', balanceSheetData, {});
                    }
                }
                
                showToast("Payment successful!", 'success');
                setTimeout(() => {
                    navigate("/doctor/invoices");
                }, 2000);
            } else {
                showToast("Payment failed. Please try again.", 'error');
            }
        } catch (error) {
            console.error("Payment error:", error);
            showToast("Payment failed. Please try again.", 'error');
        } finally {
            setProcessing(false);
        }
    };

    if (loading) {
        return (
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                <div className="text-center" style={{ padding: '50px' }}>
                    <Spinner animation="border" variant="primary" />
                    <p style={{ marginTop: '20px' }}>Loading payment details...</p>
                </div>
            </div>
        );
    }

    if (!invoice) {
        return (
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                <div className="text-center" style={{ padding: '50px' }}>
                    <h3>Invoice not found</h3>
                    <button 
                        className="btn btn-primary" 
                        onClick={() => navigate("/doctor/invoices")}
                    >
                        Back to Invoices
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
            <style>
                {`
                    .modal-dialog {
                        display: flex;
                        align-items: center;
                        min-height: calc(100vh - 1rem);
                        margin: 0.5rem auto;
                    }
                    
                    .modal-content {
                        width: 100%;
                        max-width: 500px;
                        margin: 0 auto;
                    }
                    
                    .bank-details-content {
                        padding: 10px 0;
                    }
                    
                    .bank-details-content .row {
                        border-bottom: 1px solid #eee;
                        padding: 8px 0;
                    }
                    
                    .bank-details-content .row:last-child {
                        border-bottom: none;
                    }
                `}
            </style>
            <section className="dc-haslayout dc-dbsectionspace">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <div className="dc-dashboardbox">
                            <div className="dc-dashboardboxtitle">
                                <h2>Payment Details</h2>
                            </div>
                            <div className="dc-dashboardboxcontent">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="dc-tabsinfo">
                                            <h4>Invoice Information</h4>
                                            <table className="table table-borderless">
                                                <tbody>
                                                    <tr>
                                                        <td><strong>Invoice ID:</strong></td>
                                                        <td>#{invoice.id}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Amount:</strong></td>
                                                        <td>₹{invoice.amount}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Due Date:</strong></td>
                                                        <td>{new Date(invoice.dueDate).toLocaleDateString()}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Created Date:</strong></td>
                                                        <td>{new Date(invoice.created_at).toLocaleDateString()}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Status:</strong></td>
                                                        <td>
                                                            <span className={`btn btn-${invoice.status === 'paid' ? 'success' : 'warning'}`}>
                                                                {invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="dc-tabsinfo">
                                            <h4>Payment Summary</h4>
                                            <div className="payment-summary" style={{
                                                backgroundColor: '#f8f9fa',
                                                padding: '20px',
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6'
                                            }}>
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span>Base Amount:</span>
                                                    <span>₹{parseFloat(invoice.amount || 0).toFixed(2)}</span>
                                                </div>
                                                
                                                {/* CGST */}
                                                {invoice.tax_type_cgst === "true" && (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span>CGST ({invoice.tax_rate_cgst}%):</span>
                                                        <span>₹{parseFloat(invoice.tax_amount_cgst || 0).toFixed(2)}</span>
                                                    </div>
                                                )}
                                                
                                                {/* SGST */}
                                                {invoice.tax_type_sgst === "true" && (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span>SGST ({invoice.tax_rate_sgst}%):</span>
                                                        <span>₹{parseFloat(invoice.tax_amount_sgst || 0).toFixed(2)}</span>
                                                    </div>
                                                )}
                                                
                                                {/* IGST */}
                                                {invoice.tax_type_igst === "true" && (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span>IGST ({invoice.tax_rate_igst}%):</span>
                                                        <span>₹{parseFloat(invoice.tax_amount_igst || 0).toFixed(2)}</span>
                                                    </div>
                                                )}
                                                
                                                {/* Other Tax */}
                                                {invoice.tax_type_tax === "true" && (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span>Tax ({invoice.tax_rate_tax}%):</span>
                                                        <span>₹{parseFloat(invoice.tax_amount_tax || 0).toFixed(2)}</span>
                                                    </div>
                                                )}
                                                
                                                {/* Total Tax Amount */}
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span>Total Tax:</span>
                                                    <span>₹{parseFloat(invoice.total_tax_amount || 0).toFixed(2)}</span>
                                                </div>
                                                
                                                {/* Subtotal */}
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span>Subtotal:</span>
                                                    <span>₹{(parseFloat(invoice.amount || 0) + parseFloat(invoice.total_tax_amount || 0)).toFixed(2)}</span>
                                                </div>
                                                
                                                {/* Discount */}
                                                {parseFloat(invoice.discount_amount || 0) > 0 && (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span>Discount ({parseFloat(invoice.discount || 0).toFixed(2)}%):</span>
                                                        <span style={{color: 'green'}}>-₹{parseFloat(invoice.discount_amount || 0).toFixed(2)}</span>
                                                    </div>
                                                )}
                                                
                                                <hr />
                                                
                                                {/* Total Amount */}
                                                <div className="d-flex justify-content-between mb-2">
                                                    <strong>Total Amount:</strong>
                                                    <strong>₹{parseFloat(invoice.total_amount || 0).toFixed(2)}</strong>
                                                </div>
                                                
                                                {/* Paid Amount */}
                                                {parseFloat(invoice.paid_amount || 0) > 0 && (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span>Paid Amount:</span>
                                                        <span style={{color: 'green'}}>₹{parseFloat(invoice.paid_amount || 0).toFixed(2)}</span>
                                                    </div>
                                                )}
                                                
                                                {/* Remaining Amount */}
                                                {parseFloat(invoice.paid_amount || 0) > 0 && (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <strong>Remaining Amount:</strong>
                                                        <strong style={{color: 'red'}}>₹{(parseFloat(invoice.total_amount || 0) - parseFloat(invoice.paid_amount || 0)).toFixed(2)}</strong>
                                                    </div>
                                                )}
                                                
                                                {/* Payment Status */}
                                                <div className="d-flex justify-content-between">
                                                    <span>Payment Status:</span>
                                                    <span className={`badge ${invoice.status === 'paid' ? 'bg-success' : invoice.status === 'partial_payment' ? 'bg-warning' : 'bg-danger'}`}>
                                                        {invoice.status === 'paid' ? 'Fully Paid' : 
                                                         invoice.status === 'partial_payment' ? 'Partial Payment' : 
                                                         'Pending'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <div className="dc-dashboardbox">
                            <div className="dc-dashboardboxtitle">
                                <h2>Choose Payment Method</h2>
                            </div>
                            <div className="dc-dashboardboxcontent d-flex flex-column justify-content-center align-items-center">
                                <div className="dc-formtheme dc-userform">
                                    {paymentMethods.map((method) => (
                                        console.log('method', method),
                                        method.status  === true && (
                                        <div key={method.value} className="form-group">
                                            <div className="dc-checkbox-holder" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '15px',
                                                border: '2px solid #ddd',
                                                borderRadius: '8px',
                                                marginBottom: '10px',
                                                cursor: 'pointer',
                                                backgroundColor: paymentMethod === method.value ? '#e3f2fd' : '#fff',
                                                borderColor: paymentMethod === method.value ? '#2196f3' : '#ddd'
                                            }}
                                            onClick={() => setPaymentMethod(method.value)}>
                                                <div style={{ marginRight: '15px', fontSize: '24px' }}>
                                                    <img src={method.icon} alt={method.label} style={{ width: '24px', height: '24px' }} />
                                                </div>
                                                <div>
                                                    <span style={{ fontWeight: 'bold' }}>{method.label}</span>
                                                </div>
                                                <div style={{ marginLeft: 'auto' }}>
                                                    <input
                                                        type="radio"
                                                        name="paymentMethod"
                                                        value={method.value}
                                                        checked={paymentMethod === method.value}
                                                        onChange={() => setPaymentMethod(method.value)}
                                                        style={{ width: '20px', height: '20px' }}
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                        )
                                    ))}
                                </div>
                                
                                {/* PayPal Button Container */}
                                {paymentMethod === 'paypal' && (
                                    <div id="paypal-button-container" style={{ margin: '20px 0' }}>
                                        {/* PayPal buttons will be rendered here */}
                                    </div>
                                )}
                                
                                <div className="payment-actions d-flex wl-100">
                                    <button 
                                        className="btn btn-success btn-lg wl-50 mb-3"
                                        onClick={handlePayment}
                                        disabled={processing || invoice.status === 'paid' || !settingsLoaded || (paymentMethod === 'razorpay' && !razorpayLoaded) || (paymentMethod === 'paypal' && !paypalLoaded)}
                                        style={{ 
                                            padding: '15px',
                                            fontSize: '16px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {!settingsLoaded ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Loading Payment Settings...
                                            </>
                                        ) : processing ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                {paymentMethod === 'razorpay' ? 'Opening Payment...' : 'Processing Payment...'}
                                            </>
                                        ) : invoice.status === 'paid' ? (
                                            'Already Paid'
                                        ) : paymentMethod === 'razorpay' && !razorpayLoaded ? (
                                            'Loading Razorpay...'
                                        ) : paymentMethod === 'paypal' && !paypalLoaded ? (
                                            'Loading PayPal...'
                                        ) : (
                                            `Pay ₹${(parseFloat(invoice.total_amount || 0) - parseFloat(invoice.paid_amount || 0)).toFixed(2)}`
                                        )}
                                    </button>
                                    
                                    <button 
                                        className="btn btn-secondary btn-lg wl-50 mb-3"
                                        onClick={() => navigate("/doctor/invoices")}
                                        disabled={processing}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>
            {showBankDetails && (
                    <Modal 
                        show={showBankDetails} 
                        onHide={() => setShowBankDetails(false)} 
                        centered
                        size="md"
                        backdrop="static"
                        keyboard={false}
                        style={{ zIndex: 9999 }}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Bank Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="bank-details-content">
                                <div className="row mb-3">
                                    <div className="col-6"><strong>Bank Name:</strong></div>
                                    <div className="col-6">{bankDetails.bank_name}</div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-6"><strong>Account Number:</strong></div>
                                    <div className="col-6">{bankDetails.account_number}</div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-6"><strong>Account Holder:</strong></div>
                                    <div className="col-6">{bankDetails.name}</div>
                                </div>
                                <div className="row ">
                                    <div className="col-6"><strong>Ifsc Code:</strong></div>
                                    <div className="col-6">{bankDetails.ifsc}</div>
                                </div>
                                <div className="row ">
                                    <p>Please transfer the amount to the bank account mentioned above. Once the payment is confirmed, the invoice will be marked as paid.</p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer style={{ marginTop: '0px' }}>
                            <Button variant="secondary" onClick={() => setShowBankDetails(false)}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
        </div>
    );
};

export default PaymentPage;
